import {unreadCount} from '../api/api'
import { mapState, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapState(['unread_msg']),
  },
  methods: {
    ...mapMutations(['SETUNREADMSG']),
    unreadCount() {
      return false
      unreadCount()
        .then(res => {
          if (res.data.ret !== 0) {
            this.$message({message: this.$t(res.data.msg), type: 'warning'})
          } else {
            this.SETUNREADMSG(res.data.data)
          }
        })
        .catch(function(error) {
          console.log('发生错误！', error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/unreadMsgMixin.js